import React from 'react'
import {AsideMenuItem} from './AsideMenuItem'

export function HNMSAsideMenuMain() {
  return (
    <>
      <AsideMenuItem to='/hnms' icon='home-2' title={'HealOn Network Management System'} fontIcon='bi-people-fill' />
       <div className='separator my-2'></div>
       <AsideMenuItem state={'branches'} to='/hnms/branches' icon='geolocation'  title='Branches'  hasBullet={false} />
       
       <AsideMenuItem state={'hospital'} to='/hnms/hospital' icon='home-3'    title='Hospitals'  hasBullet={false} />
   
       <AsideMenuItem
         state={'hnms-select-partners'}
         to='hnms/hnms/select-partner'
         icon='people'
         fontIcon='bi-people'
         title='Select Partner'
         hasBullet={false}
       />
    </>
  )
}
